import { render, staticRenderFns } from "./QueryOrdersPaymentsManagementComponent.vue?vue&type=template&id=daedcaae&"
import script from "./QueryOrdersPaymentsManagementComponent.vue?vue&type=script&lang=js&"
export * from "./QueryOrdersPaymentsManagementComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports